import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useTeam } from "@/lib/team";
import { Switch } from "@/components/ui/switch";
import { errorMessage } from "@/lib/billing";

// Research only mode: hides drafting and listing for people who list on their own.
export default function ResearchModeSwitch({ compact = false }) {
  const { checkAuth } = useAuth();
  const { isAssistant, researchOnly, researchPlan } = useTeam();
  const [busy, setBusy] = useState(false);
  if (isAssistant || (compact && !researchOnly)) return null;
  const toggle = async (on) => {
    setBusy(true);
    try { await api.put("/research-mode", { enabled: on }); await checkAuth(); toast.success(on ? "Research only mode on" : "Full listing tools are back"); }
    catch (e) { toast.error(errorMessage(e, "Couldn't change mode")); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-3" data-testid="research-mode-switch">
      <label className="flex items-center justify-between gap-3">
        <span className="flex items-center gap-2 text-sm font-semibold text-slate-900"><Search className="h-4 w-4 text-[#0053DA]" /> Research only mode</span>
        <Switch checked={researchOnly} disabled={busy || researchPlan} onCheckedChange={toggle} data-testid="research-mode-switch-toggle" />
      </label>
      <p className="mt-1 text-[11px] text-slate-500">
        {researchPlan
          ? <>Included in your Research plan. <Link to="/billing" className="font-semibold text-[#0053DA] hover:underline" data-testid="research-mode-upgrade">Switch to Starter or Pro</Link> to draft and list.</>
          : researchOnly
            ? "Just What's it worth, Deep Research, history and hauls. Turn off to draft and list with SnapList."
            : "For people who list on their own. Hides drafting and listing so it's just research."}
      </p>
    </div>
  );
}
